(ns entities.liabilities.specs
  (:require
    [cljs.spec.alpha :as s]
    )
  )

(s/def ::id string?)
(s/def ::name string?)
(s/def ::type #{
                "PERSONAL_LOAN"
                "MORTGAGE"
                "PROPERTY_LOAN"
                "AUTO_LOAN"
                "STUDENT_LOAN"
                "OTHER"})
(s/def ::value neg?)

(s/def ::liability (s/keys :req-un [::id
                                    ::name
                                    ::type
                                    ::value]))

(s/def ::liabilities (s/coll-of ::liability))


(s/def :patch/value (s/or :num number?
                          :str string?))
(s/def :patch/liability (s/keys :req-un [::name
                                         ::type
                                         :patch/value]))
(s/def :patch/liabilities (s/coll-of :patch/liability))
(s/def ::patch :patch/liabilities)
